<template>
  <section class="form-fw__content">
    <form
      v-if="formVisibility"
      class="form--custom"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <fieldset class="form__container" :disabled="status === isLoading">
        <header class="form__container__header">
          <h2 class="form__container__title">{{ $t('Views.EmployeeMassCreditPolicyPage.radioButtonTitle') }}</h2>
          <p class="form__container__desc">{{ $t('Views.EmployeeMassCreditPolicyPage.radioButtonSubtitle') }}</p>
        </header>

        <div class="form__container__content">
          <v-radio-group
            v-model="radioGroupEmployees"
            class="mt-0"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t('Common.employees'))"
            :data-vv-name="$t('Common.employees')"
            required
          >
            <v-radio :label="$t('Components.ApplyToAllDialog.allEmployees')" value="allEmployees"></v-radio>
            <v-radio :label="$t('Components.ApplyToAllDialog.selectEmployeesByName')" value="perName"></v-radio>
            <v-radio :label="$t('Components.ApplyToAllDialog.selectEmployeesById')" value="perId"></v-radio>
          </v-radio-group>

          <AutoComplete
            v-if="radioGroupEmployees === 'perName'"
            kind="employee"
            :data="employeeIds"
            :companyId="globalCompany.id"
            :placeholder="$t('Components.ApplyToAllDialog.searchEmployees')"
            :isValid="radioGroupEmployees === 'perName' && isEmployeeValid"
            :required="radioGroupEmployees === 'perName'"
            multiple
            @input="updateEmployee"
          />

          <v-text-field
            v-if="radioGroupEmployees === 'perId'"
            v-model="employeesIdsField"
            flat
            outline
            solo
            color="accent"
            clearable
            :name="$t('Components.ApplyToAllDialog.fieldIdsName')"
            :placeholder="$t('Components.ApplyToAllDialog.fieldIdsPlaceholder')"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t('Components.ApplyToAllDialog.fieldIdsName'))"
            :data-vv-name="$t('Components.ApplyToAllDialog.fieldIdsName')"
            required
            @blur="stringToArray"
          />
        </div>
      </fieldset>

      <fieldset
        class="form__container form__container--collapse"
        :disabled="status === isLoading"
      >
        <header class="form__container__header" @click="collapse('creditPolicyContainer')">
          <h2 class="form__container__title">
            {{ $t(`${namespace}.containerCreditPolicyTitle`) }}
            <v-tooltip slot="append" top min-width="200" max-width="200">
              <v-icon color="accent" small slot="activator">info</v-icon>
              <span>{{ $t(`${namespace}.containerCreditPolicyTooltip`) }}</span>
            </v-tooltip>
          </h2>
          <p class="form__container__desc">{{ $t(`${namespace}.containerCreditPolicyDesc`) }}</p>
          <v-icon :color="creditPolicyContainer ? 'accent' : 'gray-6'">
            {{ creditPolicyContainer ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </header>

        <div v-if="creditPolicyContainer" class="form__container__content pt-0">
          <h3 class="form__container__title">{{ $t(`${namespace}.creditPolicyContainerTabs.title`) }}</h3>

          <div class="credit-policy__tabs">
            <div
              class="credit-policy__tab__item"
              :class="[
                { 'credit-policy__tab__item--active': creditPolicyTab1 },
                { 'credit-policy__tab__item--inactive': !creditPolicyTab1 && creditPolicyTab2 },
              ]"
              @click="handlecreditPolicyTab($event, 'creditPolicyTab1', true)"
            >
              <img src="@/assets/img/controle.svg" alt="">
              <div class="credit-policy__tab__info">
                <span class="credit-policy__tab__title">{{ $t(`${namespace}.creditPolicyContainerTabs.tab1Title`) }}</span>
                <p class="credit-policy__tab__text">{{ $t(`${namespace}.creditPolicyContainerTabs.tab1Text`) }}</p>
              </div>

              <v-btn
                v-if="creditPolicyTab1"
                class="credit-policy__tab__close"
                color="accent"
                flat
                icon
                @click="handlecreditPolicyTab($event)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </div>

            <div
              class="credit-policy__tab__item"
              :class="[
                { 'credit-policy__tab__item--active': creditPolicyTab2 },
                { 'credit-policy__tab__item--inactive': !creditPolicyTab2 && creditPolicyTab1 },
              ]"
              @click="handlecreditPolicyTab($event, 'creditPolicyTab2', false)"
            >
              <img src="@/assets/img/beneflex.svg" alt="">
              <div class="credit-policy__tab__info">
                <span class="credit-policy__tab__title">{{ $t(`${namespace}.creditPolicyContainerTabs.tab2Title`) }}</span>
                <p class="credit-policy__tab__text">{{ $t(`${namespace}.creditPolicyContainerTabs.tab2Text`) }}</p>
              </div>

              <v-btn
                v-if="creditPolicyTab2"
                class="credit-policy__tab__close"
                color="accent"
                flat
                icon
                @click="handlecreditPolicyTab($event, null, false)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </div>

          <div v-if="creditPolicyTab1 || creditPolicyTab2" class="credit-policy__tabs__content">
            <div v-if="creditPolicyTab1">
              <v-checkbox v-model="useBudget" class="pb-2 mt-2 mb-2" hide-details>
                <template slot="label">
                  <label class="text--semibold">{{ $t(`${namespace}.fieldBudgetValueLabel`) }}</label>
                </template>
              </v-checkbox>

              <v-layout row wrap>
                <v-flex sm6 xs12>
                  <div class="pr-2--desktop">
                    <div>
                      <label>{{ $t(`${namespace}.fieldBudgetValueLabel2`) }}</label>
                      <v-text-field
                        v-model="budgetLimitFormatted"
                        v-money="money"
                        ref="budgetLimitFormatted"
                        :placeholder="$t(`${namespace}.fieldBudgetValuePlaceholder`)"
                        :error-messages="errors.collect($t(`${namespace}.fieldBudgetValueName`))"
                        v-validate="{ required: useBudget }"
                        :data-vv-name="$t(`${namespace}.fieldBudgetValueName`)"
                        required
                        flat
                        outline
                        solo
                        color="accent"
                      />
                    </div>
                  </div>
                </v-flex>

                <v-flex
                  :class="budgetPeriod === 'date' ? 'sm3' : 'sm6'"
                  xs12
                >
                  <div class="pl-2--desktop">
                    <label>{{ $t(`${namespace}.fieldBudgetPeriodLabel`) }}</label>
                    <v-select
                      v-model="budgetPeriod"
                      type="number"
                      :placeholder="$t(`${namespace}.fieldBudgetPeriodPlaceholder`)"
                      item-text="label"
                      :items="objectToArray($t(`${namespace}.fieldBudgetPeriodItems`))"
                      :error-messages="errors.collect($t(`${namespace}.fieldBudgetPeriodName`))"
                      v-validate="{ required: useBudget }"
                      :data-vv-name="$t(`${namespace}.fieldBudgetPeriodName`)"
                      noDataText=""
                      required
                      flat
                      outline
                      solo
                      color="accent"
                    />
                  </div>
                </v-flex>

                <v-flex
                  v-if="budgetPeriod === 'date'"
                  :class="budgetPeriod === 'date' ? 'sm3' : 'sm6'"
                  xs12
                >
                  <div class="pl-4--desktop">
                    <label>{{ $t(`${namespace}.fieldBudgetPeriodLabel2`) }}</label>
                    <v-text-field
                      v-model="budgetDate"
                      ref="budgetDate"
                      placeholder="DD/MM/AAAA"
                      slot="activator"
                      flat
                      outline
                      solo
                      color="accent"
                      append-icon="today"
                      :name="$t(`${namespace}.fieldBudgetPeriod`)"
                      mask="##/##/####"
                      return-masked-value
                      v-validate="{
                        required: true,
                        isValidDate: true,
                        date_format: 'dd/MM/yyyy'
                      }"
                      :error-messages="errors.collect($t(`${namespace}.fieldBudgetPeriod`))"
                      :data-vv-name="$t(`${namespace}.fieldBudgetPeriod`)"
                      required
                      @click:append="budgetPeriodCalendar = true"
                    />

                    <v-dialog
                      v-model="budgetPeriodCalendar"
                      ref="calendar"
                      persistent
                      lazy
                      full-width
                      width="290"
                      class="v-dialog__container--first"
                    >
                      <v-date-picker
                        v-model="budgetDateUnformatted"
                        :locale="currentLocale"
                        :min="today"
                        color="accent"
                        @change="setBudgetDate"
                      />
                    </v-dialog>
                  </div>
                </v-flex>
              </v-layout>

              <!-- TODO: -->

              <v-checkbox
                v-model="useRideCredit"
                class="pb-2 mt-2"
                hide-details
                @change="creditControlFields('checkbox')"
              >
                <template slot="label">
                  <label class="text--semibold">{{ $t(`${namespace}.fieldUseRideCreditLabel`) }}</label>
                </template>
              </v-checkbox>

              <v-layout row wrap>
                <v-flex sm6 xs12>
                  <div class="pr-2--desktop">
                    <label>{{ $t(`${namespace}.fieldUseRideCreditLabel2`) }}</label>
                    <v-text-field
                      v-model="credit"
                      type="number"
                      :placeholder="$t(`${namespace}.fieldUseRideCreditPlaceholder`)"
                      :error-messages="errors.collect($t(`${namespace}.fieldUseRideCreditName`))"
                      v-validate="{ required: Boolean(useRideCredit), min_value: 0, max_value: 99 }"
                      :data-vv-name="$t(`${namespace}.fieldUseRideCreditName`)"
                      required
                      flat
                      outline
                      solo
                      color="accent"
                      @input="creditControlFields('input')"
                    />
                  </div>
                </v-flex>

                <v-flex sm6 xs12>
                  <div class="pl-2--desktop">
                    <label>{{ $t(`${namespace}.fieldCreditPeriodLabel`) }}</label>
                    <v-select
                      v-model="useRidePeriod"
                      type="number"
                      :placeholder="$t(`${namespace}.fieldCreditPeriodPlaceholder`)"
                      item-text="label"
                      :items="objectToArray($t(`${namespace}.fieldCreditPeriodItems`))"
                      :error-messages="errors.collect($t(`${namespace}.fieldCreditPeriodName`))"
                      v-validate="{ required: Boolean(useRideCredit) }"
                      :data-vv-name="$t(`${namespace}.fieldCreditPeriodName`)"
                      noDataText=""
                      required
                      flat
                      outline
                      solo
                      color="accent"
                    />
                  </div>
                </v-flex>
              </v-layout>

              <!-- TODO: -->
            </div>

            <div v-if="creditPolicyTab2" class="input__tooltip__container">
              <label>{{ $t(`${namespace}.flexibleBenefitLabel`) }}</label>
              <v-text-field
                v-model="budgetLimitFormatted"
                v-money="money"
                ref="budgetLimitFormatted"
                :placeholder="$t(`${namespace}.fieldBudgetValuePlaceholder`)"
                :error-messages="errors.collect($t(`${namespace}.fieldBudgetValueName`))"
                v-validate="{ required: useBudget }"
                :data-vv-name="$t(`${namespace}.fieldBudgetValueName`)"
                required
                flat
                outline
                solo
                color="accent"
              />

              <v-tooltip slot="append" top min-width="200" max-width="200">
                <v-icon color="accent" slot="activator">info</v-icon>
                <span>{{ $t(`${namespace}.flexibleBenefitTooltip`) }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </fieldset>
    </form>

    <FlexibleBenefitConfirmDialog
      :visible="flexibleBenefitConfirmDialog.visible"
      :kind="flexibleBenefitConfirmDialog.kind"
      @close="handleCloseDialog"
      @confirm="handleConfirmDialog"
    />
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VMoney } from 'v-money'
import { isObject, isArray, stringToFloat, objectToArray, goBack } from 'utils/functions'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import moment from 'moment'
import FlexibleBenefitConfirmDialog from 'components/employee/FlexibleBenefitConfirmDialog'
import AutoComplete from 'components/AutoComplete'

export default {
  name: 'EmployeeForm',
  props: {
    data: {
      type: Object
    },
    submit: {
      type: Boolean
    },
    status: {
      type: Number
    }
  },
  directives: {
    money: VMoney
  },
  components: {
    FlexibleBenefitConfirmDialog,
    AutoComplete
  },
  computed: {
    ...mapState({
      globalCompany: (state) => state.company.selectedCompany,
      companies: ({ session }) => session.user.business.companies,
      isAdmin: ({ session }) => session.user.business.isAdministrator
    }),

    categoriesList () {
      return this.data && this.data.form && this.data.form.employee && this.data.form.employee.categoryIds
        ? this.data.form.employee.categoryIds
        /* todo: ridesCategoriesList */
        : objectToArray(this.$store.state.commonConfig.categories).map(item => item.value)
    },

    today () {
      return new Date().toJSON().slice(0, 10)
    },

    currentLocale () {
      return this.$i18n.locale.split('_').join('-')
    },

    flexibleBenefit () {
      return !this.useBudget || this.budgetLimitFormatted === 'R$ 0,00' || this.budgetPeriod !== 'monthly'
    },

    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED
  },
  data () {
    return {
      namespace: 'Views.EmployeePage',
      isFetching: false,

      // containers
      creditPolicyContainer: true,

      // datepicker
      budgetPeriodCalendar: false,
      budgetDateUnformatted: null,
      budgetDateFormatted: null,

      // other fields
      isEmployeeValid: true,
      radioGroupEmployees: null,
      employeeIds: [],
      employeesIdsField: null,

      budget: null,
      budgetDate: null,
      budgetPeriod: 'monthly',
      credit: null,
      useBudget: null,
      useRideCredit: null,
      budgetCumulative: false,
      budgetCurrency: null,
      useRidePeriod: null,

      // mask money config
      budgetLimitFormatted: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },

      budgetLimitFormattedOld: null,
      creditPolicyTab1: false,
      creditPolicyTab2: false,
      flexibleBenefitConfirmDialog: {
        visible: false,
        kind: null
      },
      resetAllTabs: false,
      formVisibility: true
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    isValidObject: (val) => isObject(val),

    objectToArray: (val) => objectToArray(val),

    collapse (container) {
      this[container] = !this[container]
    },

    prevPage () {
      goBack()
    },

    isValidArray (val) {
      return isArray(val)
    },

    updateEmployee (val) {
      if (!this.isValidArray(val)) {
        this.employeeIds = []
        this.radioGroupEmployees !== 'allEmployees' && (this.isEmployeeValid = false)
        return
      }

      this.employeeIds = val
      this.radioGroupEmployees !== 'allEmployees' && (this.isEmployeeValid = true)
    },

    resetEmployeeOptions () {
      this.employeeIds = []
      this.employeesIdsField = null
    },

    resetAllFields () {
      this.formVisibility = false
      this.creditPolicyTab1 = false
      this.creditPolicyTab2 = false
      this.resetAllTabs = false

      this.resetEmployeeOptions()
      this.isEmployeeValid = true
      this.radioGroupEmployees = null

      // fields
      this.budgetDate = null
      this.budgetDateFormatted = null
      this.budgetPeriod = null
      this.credit = null
      this.useRideCredit = null
      this.budget = null
      this.useBudget = null

      // flexible benefits
      this.budgetCumulative = false
      this.budgetCurrency = null

      setTimeout(() => {
        this.formVisibility = true

        if (this.$refs['budgetLimitFormatted']) {
          this.$refs['budgetLimitFormatted'].$el.querySelector('input').value = 'R$ 0,00'
        }

        scrollTo(0, 0)
      }, 100)
    },

    stringToArray () {
      if (!this.employeesIdsField) return
      const arr = this.employeesIdsField.replace(/[[A-zÀ-ú]-\s._]/g, '').split(',')
      this.employeeIds = arr.map(item => Number(item))
    },

    setBudgetDate (val) {
      this.budgetDate = this.moment(val).format('DD/MM/YYYY')
      this.budgetDateUnformatted = this.moment(val).format('YYYY-MM-DD')
      this.budgetPeriodCalendar = false

      const input = this.$refs['budgetDate'].$el.querySelector('input')
      if (input) {
        input.focus()
        setTimeout(() => { input.blur() }, 100)
      }
    },

    setFlexibleBenefits (employeeData) {
      const emp = { ...employeeData }

      if (emp.budgetCumulative) {
        // set value
        emp.budgetCurrency = emp.budget // TO DO
        // reset value
        emp.budget = null // TO DO
      } else {
        emp.budgetCurrency = null
      }

      return emp
    },

    async handleSubmit () {
      this.usagePolicySubmit = !this.usagePolicySubmit

      if (this.radioGroupEmployees !== 'allEmployees' && !this.employeeIds.length) {
        this.isEmployeeValid = false
      }

      try {
        const isValid = await this.$validator.validateAll()

        if (this.radioGroupEmployees !== 'allEmployees' && !this.employeeIds.length) return

        if (isValid) {
          this.$emit('setCurrentStatus', this.isLoading)

          this.budgetCumulative = this.creditPolicyTab2

          // WORKAROUND
          let ids = null

          if (this.radioGroupEmployees === 'perName') {
            const employeeIds = this.employeeIds.map(item => item.id)
            ids = this.employeeIds.length ? employeeIds : null
          } else {
            ids = this.employeeIds
          }

          await this.$apiService.batchUpdate(
            this.globalCompany.id,
            { budget: !this.budgetCumulative ? this.budget : null },
            { budgetDate: this.budgetDate },
            { budgetPeriod: this.budgetPeriod ? this.budgetPeriod : 'monthly' },
            { credit: this.credit },
            { useRidePeriod: this.useRidePeriod },
            { useBudget: this.useBudget },
            { useRideCredit: this.useRideCredit },

            // flexible benefits
            { budgetCumulative: this.budgetCumulative },
            { budgetCurrency: this.budgetCumulative ? this.budget : null },

            { categoryIds: null },
            { supervisorId: null },
            { thirdPartyWebCallPermission: null },
            { webCallPermission: null },
            { ids }
          )

          this.$router.push({ name: 'Employees' })
          this.successAlert(this.$t('Components.ApplyToAllDialog.usagePolicyBulkUpdateSuccess'))
          this.resetAllFields()
          this.$emit('setCurrentStatus', this.isSuccess)
        }
      } catch (err) {
        console.log('Error', err)
        this.errorAlert(this.$t('Components.ApplyToAllDialog.error'))
        this.$emit('setCurrentStatus', this.isFailed)
      }
    },

    creditControlFields (type) {
      if (type === 'checkbox') {
        !this.useRideCredit && (this.credit = null)
        return
      }

      if (type === 'input') {
        this.useRideCredit = Boolean(this.credit)
      }
    },

    resetCreditPolicyFields () {
      // ride fields
      this.useRideCredit = false
      this.credit = null

      // credit fields
      this.useBudget = false
      this.budget = null // TO DO
      this.budgetPeriod = 'monthly'
      this.budgetDate = null
      this.budgetLimitFormatted = null

      // cumulative credit fields
      this.budgetCumulative = false
      this.budgetCurrency = null

      setTimeout(() => {
        if (this.$refs['budgetLimitFormatted']) {
          this.$refs['budgetLimitFormatted'].$el.querySelector('input').value = 'R$ 0,00'
        }
      }, 60)
    },

    resetCreditPolicyTabs () {
      this.creditPolicyTab1 = false
      this.creditPolicyTab2 = false
    },

    handleCloseDialog ({ reset, tab }) {
      this.closeFlexibleBenefitConfirmDialog()

      if (tab === 'creditPolicyTab1') {
        this.creditPolicyTab1 = true
        this.creditPolicyTab2 = false
      }

      if (tab === 'creditPolicyTab2') {
        this.creditPolicyTab1 = false
        this.creditPolicyTab2 = true
        this.budgetCumulative = true
      }
    },

    handleConfirmDialog ({ reset, tab }) {
      this.closeFlexibleBenefitConfirmDialog()

      if (reset) {
        this.resetCreditPolicyTabs()
        this.resetCreditPolicyFields()
      }

      if (tab === 'creditPolicyTab1') {
        this.creditPolicyTab1 = !this.resetAllTabs
        this.creditPolicyTab2 = false
        setTimeout(() => { this.resetAllTabs = false }, 1000)
      }

      if (tab === 'creditPolicyTab2') {
        this.creditPolicyTab1 = false
        this.budgetCumulative = true
        this.creditPolicyTab2 = true
      }
    },

    handlecreditPolicyTab (event, tab = null, reset = true) {
      const isCloseButton = event && (event.target.classList.contains('v-icon') || event.target.classList.contains('credit-policy__tab__close'))

      setTimeout(() => {
        if (this.$refs['budgetLimitFormatted']) {
          this.$refs['budgetLimitFormatted'].$el.querySelector('input').value = 'R$ 0,00'
        }
      }, 100)

      if (isCloseButton && !reset) {
        this.flexibleBenefitConfirmDialog = {
          visible: true,
          kind: 'off'
        }

        this.resetAllTabs = true

        return
      }

      if (isCloseButton && reset) {
        this.resetCreditPolicyFields()
        this.resetCreditPolicyTabs()
        return
      }

      if (tab === 'creditPolicyTab2' && !this.creditPolicyTab2) {
        this.flexibleBenefitConfirmDialog = {
          visible: true,
          kind: 'on'
        }
      }

      if (tab === 'creditPolicyTab1' && this.budget > 0) {
        this.flexibleBenefitConfirmDialog = {
          visible: true,
          kind: 'off'
        }

        return
      }

      if (tab === 'creditPolicyTab1') {
        this.creditPolicyTab1 = true
        this.creditPolicyTab2 = false
      }

      if (tab === 'creditPolicyTab2') {
        this.budgetCumulative = true
      }
    },

    openFlexibleBenefitConfirmDialog (kind = 'on') {
      this.flexibleBenefitConfirmDialog = {
        visible: true,
        kind
      }
    },

    closeFlexibleBenefitConfirmDialog () {
      this.flexibleBenefitConfirmDialog = { visible: false }
    },

    convertDateToEnFormat (str) {
      return str.split('/').reverse().join('-')
    }
  },
  watch: {
    submit () {
      this.handleSubmit()
    },

    formVisibility (val) {
      // fix validation error when close dialog
      this.$validator._paused = !val
    },

    radioGroupEmployees () {
      this.resetEmployeeOptions()
    },

    employeesIdsField (val) {
      if (!val) {
        this.resetEmployeeOptions()
      }
    },

    budget (val) {
      val ? this.useBudget = true : this.useBudget = false
    },

    budgetLimitFormatted (from, to) {
      this.budget = stringToFloat(from)
      if (!this.budgetLimitFormattedOld || (from !== to)) {
        this.budgetLimitFormattedOld = from
      }
    },

    useBudget (val) {
      if (!val && !this.budgetCumulative) {
        if (this.$refs['budgetLimitFormatted']) {
          this.$refs['budgetLimitFormatted'].$el.querySelector('input').value = 0
        }

        this.budget = null
        this.budgetPeriod = 'monthly'
      }
    },

    budgetPeriod (val) {
      if (val === 'date' && !this.budgetDateUnformatted) {
        const date = this.budgetDate
          ? this.budgetDate.split('/').reverse().join('-')
          : this.today
        this.budgetDateUnformatted = date
        // this.budgetDate = moment(date).format('DD/MM/YYYY')
        return
      }

      this.budgetDateUnformatted = null
      this.budgetDate = null
    },

    creditPolicyContainer (val) {
      if (!val) {
        this.useRideCredit = false
        this.credit = null
        this.useBudget = false
        this.budget = null
        this.budgetCumulative = false
        this.budgetCurrency = null
        this.creditPolicyTab1 = false
        this.creditPolicyTab2 = false

        setTimeout(() => {
          if (this.$refs['budgetLimitFormatted']) {
            this.$refs['budgetLimitFormatted'].$el.querySelector('input').value = 'R$ 0,00'
          }
        }, 60)
      }
    },

    data (val) {
      this.setEmployeeData(val)
    },

    flexibleBenefit (val) {
      if (val) this.budgetCumulative = false
    }
  },
  created () {
    moment.locale(this.currentLocale)

    this.$validator.extend('isValidDate', {
      getMessage: field => this.$t(`${this.namespace}.invalidDate`),
      validate: value => {
        const today = moment().format('YYYY-MM-DD').valueOf()
        const date = moment(this.convertDateToEnFormat(value)).format('YYYY-MM-DD').valueOf()
        if (!value || value.length < 10 || date < today) return false
        return moment(this.convertDateToEnFormat(value))._isValid
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.form__container--first {
  min-height: 314px;
}

.form__group {
  min-height: 74px;
}

.form__no-label {
  display: block;
  margin: 10px 0 1px;
}

.form__no-label2 {
  display: block;
  margin-top: 3px;
}

.credit-policy__tabs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.credit-policy__tab__item {
  align-items: center;
  border: solid 1px $gray-2;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  min-height: 113px;
  margin-top: 12px;
  position: relative;
  transition: all .26s;

  @media (min-width: 1200px) {
    display: flex;
    flex-basis: 100%;
    flex: 1;
    padding-right: 12px;

    &:first-child { margin-right: 12px; }
    &:last-child { margin-left: 12px; }
  }

  img {
    margin-right: 12px;
  }

  &:hover:not(.credit-policy__tab__item--active),
  &.credit-policy__tab__item--active {
    background-color: $attention;
  }

  &:hover:not(.credit-policy__tab__item--active) {
    box-shadow: 0 3px 9px 0 rgba(#000, .14);
  }

  &.credit-policy__tab__item--active {
    border-color: $primary;
    cursor: default;
  }

  &.credit-policy__tab__item--inactive {

    img {
      filter: grayscale(100%);
    }
  }
}

.credit-policy__tab__title {
  display: flex;
  flex-direction: column;
  font-weight: 600;
}

.credit-policy__tab__text {
  display: block;
  margin-bottom: 0;
}

.credit-policy__tabs__content {
  display: block;
  padding-top: 24px;
}

.credit-policy__tab__close {
  position: absolute;
  right: 0;
  top: 2px;
  z-index: 5;
}
</style>

<style lang="scss">
.input__tooltip__container {
  position: relative;

  .v-icon {
    position: absolute;
    left: 8px;
    top: 37px;
    z-index: 1;
  }

  .v-text-field__slot {
    margin-left: 25px;
  }
}
</style>
